import { strings } from 'src/localization';
import { DepartmentSpec } from 'src/models';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import React, { useEffect } from 'react';
import { DepartmentContactInfo } from './DepartmentContactInfo/DepartmentContactInfo';

interface IProps {
    deptSpecs?: DepartmentSpec;
    message: string;
    headerMsg: string;
    primaryHandler: (e: any) => void;
    secondaryHandler: (e: any) => void;
    closeHandler: (e: any) => void;
    getDeptSpecs: () => void;
}

const RecordLockError = (props: IProps) => {
    const deptSpecs = props.deptSpecs;
    let customError: JSX.Element | undefined = undefined;
    let contactInfo: JSX.Element | null = null;

    // If we don't have department specs, load them.
    useEffect(() => {
        if (!deptSpecs) {
            props.getDeptSpecs();
        }
    }, [props.getDeptSpecs, deptSpecs]);

    // Build custom contact information JSX
    if (deptSpecs?.contactPhnNum) {
        contactInfo = (
            <span>
                {strings.IssuContLit}
                <DepartmentContactInfo contactPhone={deptSpecs.contactPhnNum} extension={deptSpecs.contactExt}/>
            </span>
        );
    }
    // Build custom error JSX
    customError = (
        <div>
            {strings.TroubleLit + props.message}
            {contactInfo}
        </div>
    );

    return (
        <ErrorMessage
            headerMsg={props.headerMsg}
            primaryBtnMessage={strings.TryAgain}
            secondaryBtnMessage={strings.Continue}
            customError={customError}
            primaryHandler={props.primaryHandler}
            secondaryHandler={props.secondaryHandler}
            closeHandler={props.closeHandler}
        />
    );
};

export default RecordLockError;